import { ActionTree } from 'vuex'
import { StateInterface } from '../index'
import { MemberStateInterface } from './state'
import { getAvailableCard, getPointHistory, PointHistory, getAllMemberLevels, MemberLevels } from 'apis/profile'
import { Campaign, getCampaignByCardId } from 'apis/coupon'
import types from './types'
import { find } from 'lodash'

const actions: ActionTree<MemberStateInterface, StateInterface> = {
  async loadAvailableCardData({ commit }) {
    commit(types.MEMBER_LOAD_DATA)
    const result = await getAvailableCard()
    const cards = result.results
    commit(types.MEMBER_LOAD_DONE, cards)
  },
  async loadPointHistory(
    { commit, state },
    cardId: number
  ): Promise<PointHistory[]> {
    commit(types.MEMBER_LOAD_HISTORY)
    let history: PointHistory[]
    if (cardId) {
      history = await getPointHistory(cardId)
    } else {
      if (state.availableCard.length > 0) {
        history = await getPointHistory(state.availableCard[0].id)
      } else {
        history = []
      }
    }
    commit(types.MEMBER_LOAD_HISTORY_DONE, history)

    return history
  },
  async loadMemberLevel(
    {commit}
    ): Promise<MemberLevels[]> {
      commit(types.MEMBER_LEVEL_LOAD)
      const memberLevels: MemberLevels[] = await getAllMemberLevels()
      commit(types.MEMBER_LEVEL_LOAD_DONE, memberLevels)
      return memberLevels
    },

  async loadCampaign(
    { commit, state },
    cardId: number | null = null
  ): Promise<Campaign[]> {
    commit(types.MEMBER_LOAD_CAMPAIGN, cardId)
    let campaigns: Campaign[]
    if (cardId) {
      campaigns = await getCampaignByCardId(cardId)
    } else {
      if (state.availableCard.length > 0) {
        campaigns = await getCampaignByCardId(state.availableCard[0].id)
      } else {
        campaigns = []
      }
    }
    commit(types.MEMBER_LOAD_CAMPAIGN_DONE, campaigns)

    return campaigns
  },
  async selectCampaign(
    { commit, state, dispatch },
    campaignId: string | number
  ) {
    let idx = campaignId
    if (typeof campaignId === 'string') {
      idx = parseInt(campaignId)
    }

    if (state.campaigns.length === 0) {
      await dispatch('loadAvailableCardData')
      await dispatch('loadCampaign')
      await dispatch('loadPointHistory')
    }

    // Set campaign
    const campaign = find(state.campaigns, (obj) => obj.id === idx)
    if (campaign) {
      commit(types.SELECT_CAMPAIGN, campaign)
    }
  },
}

export default actions
